const robinshoes_HandleClicks = e => {
	if ( !e.target.hasAttribute('data-onclick') ) {
		return
	}

	const products = document.querySelector('.products')

	switch ( e.target.getAttribute('data-onclick') ) {
		case 'toggle-filter':
			const filterWrapper = document.querySelector('.filter-group-wrapper')
			filterWrapper.classList.toggle('visible')
			if ( filterWrapper.classList.contains( 'visible' ) ) {
				document.body.classList.add('modal-open')
			}  else {
				document.body.classList.remove('modal-open')
			}
			break
		case 'products-2cols':
			products.classList.remove('columns-3')
			products.classList.remove('rows')
			products.classList.add('columns-2')
			break
		case 'products-3cols':
			products.classList.remove('columns-2')
			products.classList.remove('rows')
			products.classList.add('columns-3')
			break
		case 'products-rows':
			products.classList.remove('columns-2')
			products.classList.remove('columns-3')
			products.classList.add('rows')
			break
		case 'switch-size':
			const size       = e.target.innerText.replace('.', '-')
			const sizeSelect = document.getElementById('pa_maten')
			const options    = [...sizeSelect.getElementsByTagName('option')]
			const sizeOption = options.find( option => option.value === size )
			const varForm    = document.querySelector('.variations_form')
			const changeEv   = new Event('check_variations')
			const sizeLis    = [...document.querySelector('.product-sizes').getElementsByTagName('li')]
			sizeSelect.value = sizeOption.value
			varForm.dispatchEvent(changeEv)
			sizeLis.forEach( li => {li.classList.remove('selected')})
			e.target.classList.add('selected')
			checkFit()
			break
		case 'closeMessageContainer':
			const messageContainer = document.querySelector( '.woocommerce-message-container' )
			document.body.removeChild( messageContainer )
			break
	}
}

window.addEventListener('click', robinshoes_HandleClicks)

window.addEventListener('load', () => {
	if ( typeof berocket_add_filter === 'function ') {
		berocket_add_filter('ajax_load_from_pagination', () => {
			window.scroll(0, 0)
		});
	}

	const sizesList = document.querySelector('.product-sizes')
	if (sizesList) {
		const lis = [...sizesList.querySelectorAll('li')]
		lis.forEach( li => {
			if (li.innerText.replace('.', '-') === document.getElementById('pa_maten').value) {
				li.classList.add('selected')
			}
		})
	}

	jQuery( document.body ).on( 'updated_checkout', e => {
		autoCheckFreeShipping()
	})
})

const autoCheckFreeShipping = () => {
	if ( document.querySelector('#shipping_method') === null ) {
		return
	}
	const shippingMethods = [...document.querySelector('#shipping_method').getElementsByClassName('shipping_method')]
	shippingMethods.find( method => {
		if ( method.value.indexOf( 'local_pickup' ) > -1 ) {
			return method
		}
		if ( method.value.indexOf( 'free_shipping' ) > -1 ) {
			method.checked = true
			return method
		}
	})
}

window.alterQuantity = (e, dir) => {
	const input = e.target.parentElement.getElementsByTagName('input')[0]
	try {
		if (Number(input.value) > 0) {
			const newVal = dir === 'up' ? Number(input.value) + 1 : Number(input.value) - 1
			if ( newVal > Number(input.max) || newVal < 1 ) {
				alert('Zoveel hebben we er helaas niet op voorraad')
				return
			}
			input.value = newVal === 0 ? input.value : newVal
			document.getElementsByName('update_cart')[0].removeAttribute('disabled')
			document.getElementsByName('update_cart')[0].click()
			
			const int = setInterval(() => {
				if (document.getElementsByClassName('woocommerce-cart-form')[0].classList.contains('processing')) {
					return
				}
				const cartContents = document.getElementsByClassName('woocommerce-cart__content')[0]
				const cartContentsImages = [...cartContents.getElementsByTagName('img')]
				const nonLoadedImages = cartContentsImages.filter(img => !img.classList.contains('loaded'))
				if (nonLoadedImages.length === 0) {
					clearInterval(int)
					return
				}
				nonLoadedImages.forEach(img => {
					if (img.hasAttribute('data-src')) {
						img.src = img.getAttribute('data-src')
					}
				})

				autoCheckFreeShipping()
			}, 100)
		}
	} catch (e) {
		console.error(e)
	}
}

const checkFit = async () => {
	const productId = document.querySelector('.product-archive-sizeswrapper').getAttribute('data-productid')
	if ( localStorage.getItem( `fitCheckedFor${productId}` ) !== 'true' ) {
		const data = new FormData()

		data.append( 'nonce', robinshoes_ajax_obj.nonce )
		data.append( 'action', 'robinshoes_get_fit')
		data.append( 'productId', productId)

		const response = await fetch( robinshoes_ajax_obj.ajax_url, {
			method: 'POST',
			body: data
		})
		const result = await response.json()
		if ( 'klein' === result.slug || 'groot' === result.slug ) {
			const adjective = 'klein' === result.slug ? 'kleiner' : 'groter'
			const counterAdjective = 'klein' === result.slug ? 'groter' : 'kleiner'
			alert(`Let op, deze schoen valt over het algemeen ${adjective} uit, wij adviseren om een maat ${counterAdjective} te kopen.`)
		}
		localStorage.setItem( `fitCheckedFor${productId}`, 'true')
	}
}
